import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useWizard } from "store/wizard";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import Filter from "components/list/Filter";
import ListPagination from "components/list/ListPagination";

import { handleSuccessMessages } from "store/auth";
import ListFilter from "components/list/ListFilter";
import { toJalali } from "lib/helpers";
import PlayPreviewModal from "components/PlayPreviewModal";
import ReportPreviewModal from "components/ReportPreviewModal";
import { useCore } from "store/core";
import { useAuth } from "store/auth";
import { axiosInstance } from "store/auth";
import { handleDangerMessages } from "store/auth";

export default function ProductStatusList(props) {
  const auth = useAuth();
  const path = {
    baseRoute: "/panel/product-status",
    aliasName: "درخواست های انتشار",
    type: "ProductStatus",
  };
  const { type, festival_id, festival_name } = useParams();
  const core = useCore();
  const wizard = useWizard();
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    remove,
    listSearch,
    from,
    to,
    listFilter,
    total,
  } = useList();
  const [showDelete, setShowDelete] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showPlayPreview, setShowPlayPreview] = useState(false);
  const [item, setItem] = useState(false);

  useEffect(() => {
    // core.dispatch(core.getProductCategories());
    if (props.plus) {
      dispatch(wizard.updateFields({ prop: "plus_movie", value: true }));
      dispatch(listFilter(path, { plus_movie: "1" }));
    } else {
      dispatch(
        listFilter(path, { type: type ?? "", festival_id: festival_id ?? "" })
      );
    }

    dispatch(wizard.changeType(type ?? "Movie"));
    return () => {
      dispatch(clear());
    };
  }, [type]);

  const filterItems = [
    {
      type: "DATE_FROM_TO",
    },
    {
      type: "SELECT",
      name: "new_status",
      label: "وضعیت جدید",
      options: [
        { label: "منتشر شده", value: "PUBLISH" },
        { label: "پیش نویس", value: "DRAFT" },
      ],
    },
    {
      type: "SELECT",
      name: "status",
      label: "وضعیت درخواست",
      options: [
        { label: "تایید شده", value: "APPROVED" },
        { label: "در انتظار تایید", value: "PENDING" },
      ],
    },
  ];

  const updateProductStatus = async (id) => {
    try {
      await axiosInstance.put(`/panel/product-status/${id}`);
      handleSuccessMessages("با موفقیت تایید شد.");
    } catch (error) {
      console.error("خطا در تغییر وضعیت محصول:", error);
      handleDangerMessages("خطا");
    }
  };

  return (
    <>
      <PlayPreviewModal
        show={showPlayPreview}
        close={() => {
          setShowPlayPreview(false);
        }}
        title={"پیش نمایش"}
        id={item.id}
      />

      <ReportPreviewModal
        show={showReport}
        close={() => {
          setShowReport(false);
        }}
        title={"تعداد بازدید"}
        id={item.id}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">
          درخواست های انتشار
        </h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <ListFilter path={path} items={filterItems} hasExcelReport />
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {load && (
              <div className="hidden md:block mx-auto text-gray-600 text-white">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600 text-white">
                {total ? `نمایش ${from} تا ${to} از ${total}` : null}
              </div>
            )}

            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">شناسه</th>
                  <th className="whitespace-nowrap text-center">عنوان فیلم</th>
                  <th className="whitespace-nowrap text-center">وضعیت قبلی</th>
                  <th className="whitespace-nowrap text-center">وضعیت جدید</th>

                  <th className="whitespace-nowrap text-center">
                    درخواست دهنده
                  </th>

                  <th className="whitespace-nowrap text-center">تایید کننده</th>

                  <th className="whitespace-nowrap text-center">
                    وضعیت درخواست
                  </th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex  justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item) => (
                    <tr className="intro-x">
                      <td className="w-16 text-center">{item.id}</td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.product &&
                            item?.product?.detail &&
                            item?.product?.detail.title &&
                            item.product.detail.title}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.previous_status &&
                          item.previous_status == "Publish"
                            ? "منتشر شده"
                            : "پیش نویس"}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.new_status && item.new_status == "Publish"
                            ? "منتشر شده"
                            : "پیش نویس"}
                        </p>
                      </td>

                      <td className="text-center">
                        {item.requested_at &&
                          toJalali(item.requested_at, "jYYYY-jMM-jDD HH:mm")}
                        <br />
                        {item.requested_by &&
                          item.requested_by.first_name +
                            " " +
                            item.requested_by.last_name}
                      </td>
                      <td className="text-center">
                        {item.approved_at_1 &&
                          toJalali(item.approved_at_1, "jYYYY-jMM-jDD HH:mm")}
                        <br />
                        {item.approved_by1 &&
                          item.approved_by1.first_name +
                            " " +
                            item.approved_by1.last_name}
                      </td>

                      <td className="text-center">
                        <span
                          className={`btn btn-sm ${
                            item.status && item.status == "Pending"
                              ? "btn-warning"
                              : "btn-success"
                          }`}
                        >
                          {item.status && item.status == "Pending"
                            ? "در انتظار تایید"
                            : "تایید شده"}
                        </span>
                      </td>

                      <td className="table-report__action w-72">
                        {item.status && item.status === "Pending" ? (
                          <div className="flex justify-center items-center">
                            {item.requested_by &&
                            item.requested_by.id === auth.userMeta.id ? (
                              <button
                                className="btn btn-sm btn-secondary cursor-not-allowed"
                                disabled
                              >
                                درخواست کننده
                              </button>
                            ) : item.approved_by1 &&
                              item.approved_by1.id === auth.userMeta.id ? (
                              <button
                                className="btn btn-sm btn-secondary cursor-not-allowed"
                                disabled
                              >
                                تایید کننده{" "}
                              </button>
                            ) : (
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  updateProductStatus(item.id);
                                }}
                              >
                                ثبت تایید
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="flex justify-center items-center">
                            ---
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
